<template>
  <v-form :name="props.searchProps.formName" @keyup.enter="autoSearch = true">
    <Tabs value="0" scrollable>

      <TabList class="mb-4">
        <Tab value="0">{{ __('Search condition') }}</Tab>
      </TabList>

      <TabPanels>
        <TabPanel value="0">
          <div class="grid">
            <FormInputText fieldName="conversion_name" label="Conversion name" size="6" :isFocus="true"
              v-model:field="search.conversion_name" />
            <FormCalendar fieldName="Started at from" label="Started at from" size="3"
              v-model:field="search.started_at_from" />
            <FormCalendar fieldName="Started at to" label="Started at to" size="3"
              v-model:field="search.started_at_to" />
          </div>
        </TabPanel>
      </TabPanels>
    </Tabs>


    <div class="grid">
      <SearchButtons :searchProps="searchProps" :search="search" v-model:autoSearch="autoSearch" />
    </div>
  </v-form>
</template>

<script setup>
import { ref } from "vue";

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import FormCalendar from "@crud/FormCalendar.vue";
import FormInputText from "@crud/FormInputText.vue";
import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
  searchProps: Object,
})
const autoSearch = ref(false)

let search = ref({})

prepareSearch(search, props)

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
